import { Component, Input, OnInit } from '@angular/core';
import { IntegrationFieldTypeLabel, IntegrationHistoryItem, IntegrationHistoryItemTypeLabel } from '@app-model/evaluation';
import { DiffParam, SuperBidHistoryEntryType, SuperBidHistoryFieldAuction, SuperBidHistoryFieldType, VehicleSuperBidHistory } from '@app-model/vehicle';
import { OemDealerService } from '@app-services/oem-dealer.service';
import { IntegrationProviderLabel } from '@app/views/private/admin/model/advertisers';

@Component({
  selector: 'app-super-bid-history',
  templateUrl: './super-bid-history.component.html',
  styleUrls: ['../integration-history/integration-history.component.scss', './super-bid-history.component.scss']
})
export class SuperBidHistoryComponent implements OnInit {
  @Input() items: VehicleSuperBidHistory[];
  @Input() numHistoryItems: number;
  @Input() vehicleId: string;
  @Input() superBidOfferId: string;
  @Input() superBidLotId: string;
  SuperBidHistoryEntryType = SuperBidHistoryEntryType;
  SuperBidHistoryFieldAuction = SuperBidHistoryFieldAuction;
  typeError = [  "INTEGRATION_ERROR", "MISSING_MANDATORY_FIELDS", "PUT_BID_ERROR"]
  showMore = true;
  constructor(
    private readonly oemDealerService: OemDealerService
  ) { }

  ngOnInit(): void {
    this.showMore = (this.numHistoryItems > 0 && this.numHistoryItems > this.items.length);
  }

  onClickFullHistory() {
    this.showMore = !this.showMore;
    this.oemDealerService.getAllSuperBidHistories(this.vehicleId).subscribe((data) => {
      this.items = data;
    });
  }

  getItemFieldsLabels(item: VehicleSuperBidHistory): string {

    if (item.fieldTypes && item.fieldTypes.length > 0) {
      const fields = [];
      item.fieldTypes.forEach(f => fields.push(SuperBidHistoryFieldType[f]));

      return fields.join(', ');
    } else {
      return undefined;
    }
  }

  showDetailsLink(item: IntegrationHistoryItem): boolean {
    return item.method !== undefined && item.integrationUrl !== undefined;
  }

  openDetailsLink(item: IntegrationHistoryItem): void {
    item.showingDetails = true;
  }

  closeDetailsLink(item: IntegrationHistoryItem): void {
    item.showingDetails = false;
  }
}
